/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachineData
 */
export interface MachineData {
    /**
     * Data Key
     * @type {string}
     * @memberof MachineData
     */
    readonly label?: string;
    /**
     * Data Value
     * @type {string}
     * @memberof MachineData
     */
    readonly value?: string;
}

/**
 * Check if a given object implements the MachineData interface.
 */
export function instanceOfMachineData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MachineDataFromJSON(json: any): MachineData {
    return MachineDataFromJSONTyped(json, false);
}

export function MachineDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function MachineDataToJSON(value?: MachineData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

